import * as React from 'react';
import { Button } from 'react-bootstrap';
import { isUndefined } from 'lodash';

import { IControlSchema, IControlSchemaBase } from '../../core/Controls';

import {
  Component,
  I18NString,
  parseTagSanitizeAndWhitelist,
} from '../helpers/Utils';

import Field from './components/Field';

interface LabelExtra {
  design?: Array<string>;
  hint?: string;
}

export interface LabelSchema extends IControlSchemaBase {
  extra?: LabelExtra;
  description?: I18NString;
}

interface LabelProps {
  schema: LabelSchema;
}

interface LabelState {
  openInfo: boolean;
}

class Label extends Component<LabelProps, LabelState> {
  state = {
    openInfo: false,
  };

  helpClick = () => {
    this.setState(({ openInfo }) => ({
      openInfo: !openInfo,
    }));
  };

  render() {
    const { extra, value } = this.props.schema;
    let helpBtn = null;
    if (!isUndefined(this.props.schema.description)) {
      helpBtn = (
        // @ts-ignore
        <Button onClick={this.helpClick} bsStyle="primary" title="Справка">
          <span className="glyphicon glyphicon-question-sign" />
        </Button>
      );
    }
    return (
      <Field
        {...this.props.schema}
        fullwidth={
          extra && extra.design && extra.design.indexOf('fullwidth') > -1
        }
        bordered={
          extra && extra.design && extra.design.indexOf('bordered') > -1
        }
      >
        {extra && extra.hint && (
          <div
            className="alert alert-info hint"
            dangerouslySetInnerHTML={{ __html: extra.hint }}
          />
        )}
        <span>{helpBtn}</span>
        {!isUndefined(this.props.schema.description) && this.state.openInfo && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.description),
            }}
          />
        )}
        {value &&
          parseTagSanitizeAndWhitelist(
            value,
            ['div', 'p', 'br', 'u', 'b'],
            '*',
          )}
      </Field>
    );
  }
}

export function createLabel(schema: IControlSchema) {
  return <Label schema={schema as LabelSchema} />;
}
